<t4-header icon="glyphicon-stats">
  <button mat-button color="primary" matTooltip="{{ 'Turbo.OneWayAdmin.Service.cmdFind' | translate:'Find Request'}}" (click)="FindIssue()"><mat-icon>search</mat-icon></button>
</t4-header>
<h1>{{ 'Turbo.OneWayAdmin.Service.Headline' | translate:'Active service requests'}}</h1>

<t4-container title=" ">
  <mat-form-field style="max-width:400px;">
    <mat-label>Owners</mat-label>
    <mat-select [formControl]="groupsControl" multiple (selectionChange)="applyFilter()">
      <mat-option [value]="r" *ngFor="let r of owners">{{r}}</mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field style="width: 100%;">
    <input matInput placeholder="{{ 'Turbo.OneWayAdmin.Service.lblFilter' | translate:'Find issues'}}" [(ngModel)]="filterText" (ngModelChange)="filter($event)">
  </mat-form-field>
</t4-container>

<t4-container title=" ">
  <mat-tab-group (selectedTabChange)="tabChange($event)">

    <mat-tab label="{{ 'Turbo.OneWayAdmin.Service.headUrgentissues' | translate:'Urgent issues'}} ({{ urgentIssues?.data?.filteredData?.length }})" *ngIf="Settings.isInAny(['OneWayAdmin'])">

      <t4-data-table #urgentIssues matSortActive="CreatedAt" [allowFilter]="false" [rawData]="filteredUrgentInsuranceCases" headline="" matSort [filterFields]="['Country','userId', 'RequestNo', 'InsuranceId', 'RentalObject.Title', 'RentalObject.RentalLocation.Name', 'RentalObject.RentalLocation.City', 'Type.Alias', 'IsEnabled','Owner']" [autoGenerateColumns]="false">

        <!-- ID Column -->
        <ng-container matColumnDef="userId">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 50px;"></mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 50px;" (click)="showDetails(row.Id)"><div class="statusIcon" [ngClass]="{'status-red': (row.CreatedAt < threeDaysBack), 'status-yellow': (row.CreatedAt < yesterday && row.CreatedAt >= threeDaysBack) }"></div></mat-cell>
        </ng-container>

        <ng-container matColumnDef="Country">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblCountry' | translate:'Country'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.Country }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="InsuranceId">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblRequestNo' | translate:'Issue Id'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.InsuranceId }}</mat-cell>
        </ng-container>

        <!-- Progress Column -->
        <ng-container matColumnDef="CreatedAt">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblCreated' | translate:'Created at'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.CreatedAt | date : 'yyMMdd' }}</mat-cell>
        </ng-container>

        <!-- Color Column -->
        <ng-container matColumnDef="RentalObject.Title">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblTrailer' | translate:'Trailer'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;"><t4-object-link [objectId]="row.RentalObject.Id">{{row.RentalObject.Title}}</t4-object-link></mat-cell>
        </ng-container>
        <ng-container matColumnDef="RentalObject.RentalLocation.Name">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 200px;">{{ 'Turbo.OneWayAdmin.Service.lblTrailer' | translate:'Trailer'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 200px;"><t4-location-link [locationId]="row.RentalObject.RentalLocation.Id">{{ row.RentalObject.RentalLocation.Name }}</t4-location-link></mat-cell>
        </ng-container>
        <ng-container matColumnDef="Status">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 150px;">
            {{
 'Turbo.OneWayAdmin.Service.lblStatus' | translate:'Status'
            }}
          </mat-header-cell>
          <mat-cell *matCellDef="let row" (click)="showDetails(row.Id)" style="flex: 0 0 150px;">{{ 'Turbo.OneWayAdmin.Service.ServiceStatus.' + row.Status | translate }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Owner">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;" >{{ 'Turbo.OneWayAdmin.Service.lblOwner' | translate:'Owner'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.Owner }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Description">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Turbo.OneWayAdmin.Service.lblDescription' | translate:'Description'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" (click)="showDetails(row.Id)">{{ row.Description }}</mat-cell>
        </ng-container>


      </t4-data-table>


    </mat-tab>

    <mat-tab label="{{ 'Turbo.OneWayAdmin.Service.headNewIssues2' | translate:'New issues'}} ({{ newIssues?.data?.filteredData?.length }})" *ngIf="Settings.isInAny(['OneWayAdmin'])">

      <t4-data-table #newIssues matSortActive="CreatedAt" [rawData]="filteredNewInsuranceRequests" [allowFilter]="false" headline="" matSort [filterFields]="['Country','userId', 'RequestNo', 'InsuranceId', 'RentalObject.Title', 'RentalObject.RentalLocation.Name', 'RentalObject.RentalLocation.City', 'Type.Alias', 'IsEnabled','Owner']" [autoGenerateColumns]="false">

        <!-- ID Column -->
        <ng-container matColumnDef="userId">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 50px;"></mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 50px;" (click)="showDetails(row.Id)"><div class="statusIcon" [ngClass]="{'status-red': (row.CreatedAt < threeDaysBack), 'status-yellow': (row.CreatedAt < yesterday && row.CreatedAt >= threeDaysBack) }"></div></mat-cell>
        </ng-container>

        <ng-container matColumnDef="Country">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblCountry' | translate:'Country'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.Country }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="InsuranceId">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblRequestNo' | translate:'Issue Id'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.InsuranceId }}</mat-cell>
        </ng-container>

        <!-- Progress Column -->
        <ng-container matColumnDef="CreatedAt">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblCreated' | translate:'Created at'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.CreatedAt | date : 'yyMMdd' }}</mat-cell>
        </ng-container>

        <!-- Color Column -->
        <ng-container matColumnDef="RentalObject.Title">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblTrailer' | translate:'Trailer'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;"><t4-object-link [objectId]="row.RentalObject.Id">{{row.RentalObject.Title}}</t4-object-link></mat-cell>
        </ng-container>
        <ng-container matColumnDef="RentalObject.RentalLocation.Name">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 200px;">{{ 'Turbo.OneWayAdmin.Service.lblTrailer' | translate:'Trailer'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 200px;"><t4-location-link [locationId]="row.RentalObject.RentalLocation.Id">{{ row.RentalObject.RentalLocation.Name }}</t4-location-link></mat-cell>
        </ng-container>
        <ng-container matColumnDef="Status">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 150px;">
            {{
 'Turbo.OneWayAdmin.Service.lblStatus' | translate:'Status'
            }}
          </mat-header-cell>
          <mat-cell *matCellDef="let row" (click)="showDetails(row.Id)" style="flex: 0 0 150px;">{{ 'Turbo.OneWayAdmin.Service.ServiceStatus.' + row.Status | translate }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Owner">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblOwner' | translate:'Owner'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.Owner }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Description">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Turbo.OneWayAdmin.Service.lblDescription' | translate:'Description'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" (click)="showDetails(row.Id)">{{ row.Description }}</mat-cell>
        </ng-container>

      </t4-data-table>
    </mat-tab>

    <mat-tab label="{{ 'Turbo.OneWayAdmin.Service.headActiveIssues' | translate:  'Handled issues, waiting for response'}} ({{ handledIssues?.data?.filteredData?.length }})" *ngIf="Settings.isInAny(['OneWayAdmin'])">

      <t4-data-table #handledIssues matSortActive="ExpectedResolveDate" [rawData]="filteredHandledInsuranceRequests" [allowFilter]="false" headline="" matSort [filterFields]="['Country','InsuranceId', 'RequestNo', 'RentalObject.Title', 'RentalObject.RentalLocation.Name', 'RentalObject.RentalLocation.City', 'Owner']" [autoGenerateColumns]="false">

        <!-- ID Column -->
        <ng-container matColumnDef="userId">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 50px;"></mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 50px;" (click)="showDetails(row.Id)"><div class="statusIcon" [ngClass]="{'status-red': (row.ExpectedResolveDate < threeDaysBack), 'status-yellow': (row.ExpectedResolveDate < yesterday && row.ExpectedResolveDate >= threeDaysBack) }"></div></mat-cell>
        </ng-container>

        <ng-container matColumnDef="Country">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblCountry' | translate:'Country'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.Country }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="InsuranceId">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblRequestNo' | translate:'Issue Id'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.InsuranceId }}</mat-cell>
        </ng-container>

        <!-- Progress Column -->
        <ng-container matColumnDef="ExpectedResolveDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblExpectedResolveDate' | translate:'Expected'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.ExpectedResolveDate | date : 'yyMMdd' }}</mat-cell>
        </ng-container>

        <!-- Color Column -->
        <ng-container matColumnDef="RentalObject.Title">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblTrailer' | translate:'Trailer'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;"><t4-object-link [objectId]="row.RentalObject.Id">{{row.RentalObject.Title}}</t4-object-link></mat-cell>
        </ng-container>
        <ng-container matColumnDef="RentalObject.RentalLocation.Name">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 200px;">
            {{
 'Turbo.OneWayAdmin.Service.lblTrailer' | translate:'Trailer'
            }}
          </mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 200px;"><t4-location-link [locationId]="row.RentalObject.RentalLocation.Id">{{ row.RentalObject.RentalLocation.Name }}</t4-location-link></mat-cell>
        </ng-container>
        <ng-container matColumnDef="Status">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 150px;">{{'Turbo.OneWayAdmin.Service.lblStatus' | translate:'Status' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" (click)="showDetails(row.Id)" style="flex: 0 0 150px;">{{ 'Turbo.OneWayAdmin.Service.ServiceStatus.' + row.Status | translate }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Owner">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblOwner' | translate:'Owner'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.Owner }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Description">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Turbo.OneWayAdmin.Service.lblDescription' | translate:'Description'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" (click)="showDetails(row.Id)">{{ row.Description }}</mat-cell>
        </ng-container>

      </t4-data-table>
    </mat-tab>

    <mat-tab label="{{ 'Turbo.OneWayAdmin.Service.headAllActiveIssues' | translate:'All active issues'}} ({{ activeIssues?.data?.filteredData?.length }})">

      <t4-data-table matSortActive="CreatedAt" #activeIssues [rawData]="filteredActiveInsuranceRequests" headline="" [allowFilter]="false" matSort [filterFields]="['Country','InsuranceId', 'RequestNo', 'RentalObject.Title', 'RentalObject.RentalLocation.Name', 'RentalObject.RentalLocation.City', 'Owner']" [autoGenerateColumns]="false">

        <!-- ID Column -->
        <ng-container matColumnDef="userId">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 50px;"></mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 50px;" (click)="showDetails(row.Id)"><div class="statusIcon" [ngClass]="{'status-red': (row.CreatedAt < threeDaysBack), 'status-yellow': (row.CreatedAt < yesterday && row.CreatedAt >= threeDaysBack) }"></div></mat-cell>
        </ng-container>
        <ng-container matColumnDef="Country">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblCountry' | translate:'Country'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.Country }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="InsuranceId">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblRequestNo' | translate:'Issue Id'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.InsuranceId }}</mat-cell>
        </ng-container>

        <!-- Progress Column -->
        <ng-container matColumnDef="CreatedAt">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblCreated' | translate:'Created at'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.CreatedAt | date : 'yyMMdd' }}</mat-cell>
        </ng-container>

        <!-- Color Column -->
        <ng-container matColumnDef="RentalObject.Title">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblTrailer' | translate:'Trailer'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;"><t4-object-link [objectId]="row.RentalObject.Id">{{row.RentalObject.Title}}</t4-object-link></mat-cell>
        </ng-container>
        <ng-container matColumnDef="RentalObject.RentalLocation.Name">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 200px;">{{ 'Turbo.OneWayAdmin.Service.lblTrailer' | translate:'Trailer'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 200px;"><t4-location-link [locationId]="row.RentalObject.RentalLocation.Id">{{ row.RentalObject.RentalLocation.Name }}</t4-location-link></mat-cell>
        </ng-container>
        <ng-container matColumnDef="Status">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 150px;">
            {{
 'Turbo.OneWayAdmin.Service.lblStatus' | translate:'Status'
            }}
          </mat-header-cell>
          <mat-cell *matCellDef="let row" (click)="showDetails(row.Id)" style="flex: 0 0 150px;">{{ 'Turbo.OneWayAdmin.Service.ServiceStatus.' + row.Status | translate }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Owner">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblOwner' | translate:'Owner'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.Owner }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Description">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Turbo.OneWayAdmin.Service.lblDescription' | translate:'Description'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" (click)="showDetails(row.Id)">{{ row.Description }}</mat-cell>
        </ng-container>

      </t4-data-table>
    </mat-tab>

    <mat-tab label="{{ 'Turbo.OneWayAdmin.Service.Incomplete' | translate:'Incomplete issues'}} ({{ incompleteIssues?.data?.filteredData?.length }})" *ngIf="Settings.isInAny(['OneWayAdmin'])">

      <t4-data-table matSortActive="CreatedAt" #incompleteIssues [rawData]="filteredIncompleteInsuranceRequests" [allowFilter]="false" headline="" matSort [filterFields]="['InsuranceId', 'RequestNo', 'RentalObject.Title', 'RentalObject.RentalLocation.Name', 'RentalObject.RentalLocation.City','Owner']" [autoGenerateColumns]="false">

        <!-- ID Column -->
        <ng-container matColumnDef="userId">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 50px;"></mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 50px;" (click)="showDetails(row.Id)"><div class="statusIcon" [ngClass]="{'status-red': (row.CreatedAt < threeDaysBack), 'status-yellow': (row.CreatedAt < yesterday && row.CreatedAt >= threeDaysBack) }"></div></mat-cell>
        </ng-container>

        <ng-container matColumnDef="Country">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblCountry' | translate:'Country'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.Country }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="InsuranceId">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblRequestNo' | translate:'Issue Id'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.InsuranceId }}</mat-cell>
        </ng-container>

        <!-- Progress Column -->
        <ng-container matColumnDef="CreatedAt">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblCreated' | translate:'Created at'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.CreatedAt | date : 'yyMMdd' }}</mat-cell>
        </ng-container>

        <!-- Color Column -->
        <ng-container matColumnDef="RentalObject.Title">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblTrailer' | translate:'Trailer'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;"><t4-object-link [objectId]="row.RentalObject.Id">{{row.RentalObject.Title}}</t4-object-link></mat-cell>
        </ng-container>
        <ng-container matColumnDef="RentalObject.RentalLocation.Name">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 200px;">{{ 'Turbo.OneWayAdmin.Service.lblTrailer' | translate:'Trailer'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 200px;"><t4-location-link [locationId]="row.RentalObject.RentalLocation.Id">{{ row.RentalObject.RentalLocation.Name }}</t4-location-link></mat-cell>
        </ng-container>
        <ng-container matColumnDef="Status">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 150px;">
            {{
 'Turbo.OneWayAdmin.Service.lblStatus' | translate:'Status'
            }}
          </mat-header-cell>
          <mat-cell *matCellDef="let row" (click)="showDetails(row.Id)" style="flex: 0 0 150px;">{{ 'Turbo.OneWayAdmin.Service.ServiceStatus.' + row.Status | translate }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Owner">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblOwner' | translate:'Owner'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.Owner }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Description">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Turbo.OneWayAdmin.Service.lblDescription' | translate:'Description'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" (click)="showDetails(row.Id)">{{ row.Description }}</mat-cell>
        </ng-container>

      </t4-data-table>

    </mat-tab>

    <mat-tab label="{{ 'Turbo.OneWayAdmin.Service.Finished' | translate:'Completed issues'}}" *ngIf="Settings.isInAny(['OneWayAdmin'])" (click)="showCompleted()">

      <t4-data-table *ngIf="displayCompleted" matSortActive="CreatedAt" #completedIssues [rawData]="filteredCompletedInsuranceRequests" [allowFilter]="false" headline="" matSort [filterFields]="['Country','InsuranceId', 'RequestNo', 'RentalObject.Title', 'RentalObject.RentalLocation.Name', 'RentalObject.RentalLocation.City', 'Owner']" [autoGenerateColumns]="false">

        <!-- ID Column -->
        <ng-container matColumnDef="userId">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 50px;"></mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 50px;" (click)="showDetails(row.Id)"><div class="statusIcon" [ngClass]="{'status-red': (row.CreatedAt < threeDaysBack), 'status-yellow': (row.CreatedAt < yesterday && row.CreatedAt >= threeDaysBack) }"></div></mat-cell>
        </ng-container>

        <ng-container matColumnDef="Country">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblCountry' | translate:'Country'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.Country }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="InsuranceId">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblRequestNo' | translate:'Issue Id'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.InsuranceId }}</mat-cell>
        </ng-container>

        <!-- Progress Column -->
        <ng-container matColumnDef="CreatedAt">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblCreated' | translate:'Created at'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.CreatedAt | date : 'yyMMdd' }}</mat-cell>
        </ng-container>

        <!-- Color Column -->
        <ng-container matColumnDef="RentalObject.Title">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblTrailer' | translate:'Trailer'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;"><t4-object-link [objectId]="row.RentalObject.Id">{{row.RentalObject.Title}}</t4-object-link></mat-cell>
        </ng-container>
        <ng-container matColumnDef="RentalObject.RentalLocation.Name">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 200px;">{{ 'Turbo.OneWayAdmin.Service.lblTrailer' | translate:'Trailer'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 200px;"><t4-location-link [locationId]="row.RentalObject.RentalLocation.Id">{{ row.RentalObject.RentalLocation.Name }}</t4-location-link></mat-cell>
        </ng-container>
        <ng-container matColumnDef="Status">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 150px;">
            {{
 'Turbo.OneWayAdmin.Service.lblStatus' | translate:'Status'
            }}
          </mat-header-cell>
          <mat-cell *matCellDef="let row" (click)="showDetails(row.Id)" style="flex: 0 0 150px;">{{ 'Turbo.OneWayAdmin.Service.ServiceStatus.' + row.Status | translate }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Owner">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="flex: 0 0 100px;">{{ 'Turbo.OneWayAdmin.Service.lblOwner' | translate:'Owner'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="flex: 0 0 100px;" (click)="showDetails(row.Id)">{{ row.Owner }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="Description">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Turbo.OneWayAdmin.Service.lblDescription' | translate:'Description'}}</mat-header-cell>
          <mat-cell *matCellDef="let row" (click)="showDetails(row.Id)">{{ row.Description }}</mat-cell>
        </ng-container>

      </t4-data-table>

    </mat-tab>
  </mat-tab-group>
</t4-container>
